import { type ClassValue, clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

/**
 * `min-h-touch` / `min-w-touch` (the 44px WCAG target, added to the Tailwind
 * theme in tailwind.config.ts) aren't in tailwind-merge's built-in min-height /
 * min-width scales, so out of the box it treats them as unknown classes and
 * won't resolve them against an override. Both declarations then survive the
 * merge and the 44px wins by stylesheet order — a control asking for `min-h-0`
 * silently keeps a 44px box. Registering them in the right groups makes the
 * override behave like every other Tailwind conflict.
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "min-h": [{ "min-h": ["touch"] }],
      "min-w": [{ "min-w": ["touch"] }],
    },
  },
});

/** Merge conditional class names, resolving Tailwind conflicts. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
